import Cookie from 'js-cookie'
import qs from 'querystring'
export function getUserInfo () {
  if (typeof window !== 'undefined' && window.location) {
    let search = window.location.search
    if (search) {
      search = search.indexOf('?') === 0 ? search.replace(/^\?+/, '') : search
      let query = qs.parse(search)
      if (query && query.token) {
        return {
          token: query.token,
          id: query.uid || ''
        }
      }
    }
  }
  return Cookie.getJSON('ss_user')
}



/** WEBPACK FOOTER **
 ** ./src/common/user.js
 **/